import React, { Component, ReactElement } from 'react';

import uuid from 'uuid/v4';

import { ModalType } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { eventListener, oneOf, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { SubmittableFragment } from '@philips-emr/tws-engine';
import { enumValues } from '@philips-emr/tws-utils';

import { Modal } from '..';

interface LocatorModalProps {
  fragment: string;
  modalType: ModalType;
  onClose: () => void;
  onSubmit: (event: Record<string, Value>) => void;
}

class LocatorModal extends Component<LocatorModalProps> {

  static propTypes = {
    fragment: string,
    modalType: oneOf(enumValues(ModalType)),
    onClose: eventListener,
  };

  render(): ReactElement {
    const { fragment, modalType, onClose, onSubmit } = this.props;

    const fragmentProps = { 
      disposable: true,
      fragment, 
      instanceUUID: uuid(),
      onSubmit,
      propagate: true,
      uuid: uuid(), 
    };

    return (
      <Modal
        focusOnOpen={false}
        onClose={onClose}
        type={modalType}
      >
        <SubmittableFragment  {...fragmentProps} />
      </Modal>
    );
  }
}

export default LocatorModal;
